import { Card, Code, Link, Pane, Paragraph, Strong } from 'evergreen-ui'

import Flex from '~/components/Flex'
import { IDeploy } from '~/interfaces/netlify/Deploy'
import { truncate } from '~/utils/string'

type Props = {
  handleClick: Function
  deploy: IDeploy
}

export default function NetlifyDeploy(props: Props) {
  const { deploy, handleClick } = props

  return (
    <Card
      key={deploy.id}
      background="white"
      cursor="pointer"
      elevation={1}
      hoverElevation={2}
      marginBottom={8}
      minWidth={400}
      onClick={() => handleClick(deploy.id)}
      padding={16}
      position="relative"
      width="100%"
    >
      <Flex>
        <Flex justifyContent="flex-start">
          <Pane>
            <Link size={500}>Deploy Preview #{deploy.number}</Link>
            <Paragraph color="muted" marginY="default" size={300}>
              <Code size={300}>
                {deploy.branch}@{truncate(deploy.sha)}
              </Code>
            </Paragraph>
            <Paragraph>
              Last commit by <Strong>{deploy.committer}</Strong>
            </Paragraph>
          </Pane>
        </Flex>
      </Flex>
    </Card>
  )
}
